import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    roleGroups: [],
  }),

  mutations: {
    setRoleGroups(state, roleGroups) {
      Vue.set(state, "roleGroups", roleGroups);
    },
    setDefaultRoleGroupModule(state) {
      Vue.set(state, "roleGroups", []);
    },
  },

  actions: {
    //TODO: load, update, create
    loadPublishedRoleGroups: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/role-groups/entity/published").then((response) => {
        context.commit("setRoleGroups", response.data);
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
  },
  getters: {
    getRoleGroups: (state) => {
      return state.roleGroups;
    },
  },
};
